import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGalleryImages, GalleryImage } from '../../hooks/useGalleryDB';

const DEFAULT_IMAGES: GalleryImage[] = [
  { id: 'default-1', src: 'https://i.ibb.co/3YdRwHbB/480582835-2181606785625567-3057077296093305233-n.jpg', alt: 'Electrical Repairs', uploadedAt: 0 },
  { id: 'default-2', src: 'https://i.ibb.co/rKvdqLqK/497908311-1214557047034863-3364707288013603769-n.jpg', alt: 'Consumer Unit Upgrade', uploadedAt: 0 },
  { id: 'default-3', src: 'https://i.ibb.co/N2Tc4FPF/506796606-1214560377034530-4777178540819997255-n.jpg', alt: 'Electrical Installation', uploadedAt: 0 },
  { id: 'default-4', src: 'https://i.ibb.co/0yVpBhPR/38218373-531616613957934-6726459659357519872-n.jpg', alt: 'Smart Home Installation', uploadedAt: 0 },
  { id: 'default-5', src: 'https://i.ibb.co/0j43YVKj/38290551-531616050624657-4877571857286430720-n.jpg', alt: 'EV Charger Installation', uploadedAt: 0 },
  { id: 'default-6', src: 'https://i.ibb.co/QF5njkpM/38763039-538696089916653-2169134921736519680-n.jpg', alt: 'Electrical Fault Finding', uploadedAt: 0 },
  { id: 'default-7', src: 'https://i.ibb.co/TDrkHPb0/50314711-634538543665740-3882336778417340416-n.jpg', alt: 'Consumer Unit Installation', uploadedAt: 0 },
  { id: 'default-8', src: 'https://i.ibb.co/vCkLyxp4/50505583-634538576999070-6703315287485186048-n.jpg', alt: 'Electrical Installation Work', uploadedAt: 0 },
  { id: 'default-9', src: 'https://i.ibb.co/7d2TVD3k/50658301-639219823197612-1472516235919884288-n.jpg', alt: 'Fire Alarm Installation', uploadedAt: 0 },
  { id: 'default-10', src: 'https://i.ibb.co/gZxF5051/50745198-639219803197614-3241420949391671296-n.jpg', alt: 'Smoke Alarm Installation', uploadedAt: 0 },
  { id: 'default-11', src: 'https://i.ibb.co/V05WFN8k/52397766-654296045023323-6511762653776445440-n.jpg', alt: 'Electrical Installation Work', uploadedAt: 0 },
  { id: 'default-12', src: 'https://i.ibb.co/HLRs3g0y/52877933-657601708026090-7521713879739531264-n.jpg', alt: 'Electrical Panel Work', uploadedAt: 0 },
  { id: 'default-13', src: 'https://i.ibb.co/cXVfxK99/52951137-657601794692748-7994696285628137472-n.jpg', alt: 'Lighting Installation', uploadedAt: 0 },
  { id: 'default-14', src: 'https://i.ibb.co/SXmWmVj0/53145624-657601748026086-3365799414122676224-n.jpg', alt: 'Electrical Panel Work', uploadedAt: 0 },
  { id: 'default-15', src: 'https://i.ibb.co/RJRsdTY/53518720-657601671359427-4824771913056256000-n.jpg', alt: 'Rewiring Project', uploadedAt: 0 },
  { id: 'default-16', src: 'https://i.ibb.co/gLdqY2Nx/62554425-716656608787266-2846398122685366272-n.jpg', alt: 'Commercial Electrical Work', uploadedAt: 0 },
  { id: 'default-17', src: 'https://i.ibb.co/Wvs5FtSL/395084367-829871988836706-8165738220758158812-n.jpg', alt: 'Electrical Installation', uploadedAt: 0 },
  { id: 'default-18', src: 'https://i.ibb.co/6RzF7d59/480368214-2181606872292225-596240667802637361-n.jpg', alt: 'Commercial Installation', uploadedAt: 0 },
  { id: 'default-19', src: 'https://i.ibb.co/LzNkjqnC/480446437-2181606865625559-6971354775830383732-n.jpg', alt: 'Socket and Switch Installation', uploadedAt: 0 },
  { id: 'default-20', src: 'https://i.ibb.co/Y7XpQDYq/480505180-2181593792293533-1137934850894956583-n.jpg', alt: 'Electrical Testing', uploadedAt: 0 },
  { id: 'default-21', src: 'https://i.ibb.co/ccLJGPWr/480514675-2181606738958905-3970453542309548896-n.jpg', alt: 'EICR Testing', uploadedAt: 0 },
];

export default function GalleryPage() {
  const navigate = useNavigate();
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const { images: uploadedImages, loading } = useGalleryImages();

  // Combine uploaded images (shown first) with default images
  const allImages = [...uploadedImages, ...DEFAULT_IMAGES];

  useEffect(() => {
    document.title = 'Electrical Work Gallery Watford | Beyond Electrical Services';

    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'View our portfolio of completed electrical installations, repairs & safety work across Watford & Hertfordshire. NICEIC approved electricians. Quality workmanship guaranteed. Call 020 3198 1818.');
    }

    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta');
      (metaKeywords as HTMLMetaElement).name = 'keywords';
      document.head.appendChild(metaKeywords);
    }
    (metaKeywords as HTMLMetaElement).content = 'electrician gallery Watford, electrical work photos Watford, Beyond Electrical portfolio, NICEIC electrician work Watford';

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      (canonical as HTMLLinkElement).rel = 'canonical';
      document.head.appendChild(canonical);
    }
    (canonical as HTMLLinkElement).href = 'https://beyondelectrical.co.uk/gallery';

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'gallery-schema';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "ImageGallery",
      "name": "Beyond Electrical Services – Work Gallery",
      "description": "Portfolio of electrical installations, repairs and safety work completed by Beyond Electrical Services across Watford and Hertfordshire.",
      "url": "https://beyondelectrical.co.uk/gallery",
      "author": {
        "@type": "LocalBusiness",
        "name": "Beyond Electrical Services"
      }
    });
    document.head.appendChild(script);

    return () => {
      const s = document.getElementById('gallery-schema');
      if (s) document.head.removeChild(s);
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#0A1628]">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-[#0A1628]/96 backdrop-blur-lg shadow-lg shadow-[#FFD700]/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            <div className="flex items-center gap-4">
              <button
                onClick={() => navigate('/')}
                className="text-[#FFD700] hover:text-[#FFC700] transition-colors cursor-pointer"
                aria-label="Back to Home"
              >
                <i className="ri-arrow-left-line text-2xl"></i>
              </button>
              <img
                src="https://static.readdy.ai/image/4a891bf01ca77aa59d4e684a3f5f885b/259e2fbe55ce965c9eea2645e77c4653.png"
                alt="Beyond Electrical Services Logo"
                className="h-12 w-auto cursor-pointer"
                onClick={() => navigate('/')}
              />
            </div>
            <a
              href="tel:02031981818"
              className="bg-[#FFD700] text-[#0A1628] px-6 py-2 rounded-full font-semibold hover:bg-[#FFC700] transition-all duration-300 shadow-lg hover:shadow-[#FFD700]/50 text-sm whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
            >
              <i className="ri-phone-fill"></i>
              020 3198 1818
            </a>
          </div>
        </div>
      </nav>

      {/* Gallery Content */}
      <div className="pt-32 pb-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-4">
              Our <span className="text-[#FFD700]">Work Gallery</span>
            </h1>
            <p className="text-gray-400 text-lg">
              Browse through our completed projects across Watford, Rickmansworth &amp; surrounding areas
            </p>
          </div>

          {/* Loading state */}
          {loading ? (
            <div className="flex items-center justify-center py-24">
              <i className="ri-loader-4-line text-[#FFD700] text-4xl animate-spin"></i>
            </div>
          ) : (
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
              {allImages.map((image) => (
                <div
                  key={image.id}
                  className="group relative aspect-square overflow-hidden rounded-lg cursor-pointer bg-[#0D1F3C]"
                  onClick={() => setSelectedImage(image.src)}
                >
                  <img
                    src={image.src}
                    alt={image.alt}
                    className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0A1628] via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <div className="absolute bottom-0 left-0 right-0 p-4">
                      <i className="ri-zoom-in-line text-[#FFD700] text-2xl"></i>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Call to Action */}
          <div className="mt-16 text-center">
            <p className="text-gray-300 text-lg mb-6">
              Ready to start your electrical project?
            </p>
            <a
              href="/#contact"
              className="inline-flex items-center gap-3 bg-[#FFD700] text-[#0A1628] px-8 py-4 rounded-full font-bold text-lg hover:bg-[#FFC700] transition-all duration-300 shadow-xl hover:shadow-[#FFD700]/50 hover:scale-105 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-flashlight-line"></i>
              Get a Free Quote
            </a>
          </div>
        </div>
      </div>

      {/* Lightbox */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <button
            className="absolute top-4 right-4 text-white text-4xl hover:text-[#FFD700] transition-colors cursor-pointer"
            onClick={() => setSelectedImage(null)}
            aria-label="Close"
          >
            <i className="ri-close-line"></i>
          </button>
          <img
            src={selectedImage}
            alt="Gallery Image"
            className="max-w-full max-h-full object-contain"
          />
        </div>
      )}
    </div>
  );
}
